; (function ($) {
	$(function () {
		const $video = $('.media-video');
		const $videoControlButton = $('.video-control-button');
		const $videoControlButtonContainer = $('.video-control-button-container');
		let isVideoPlaying = false;

		// Check if video exists
		if ($video.length === 0) {
			return; // Exit if no video is present
		}

		// Handle prefers-reduced-motion
		const reducedMotionMediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
		if (!reducedMotionMediaQuery || reducedMotionMediaQuery.matches) {
			window.noMotion = true;
		}

		// Initialize video state
		isVideoPlaying = !window.noMotion;

		function playVideo() {
			$video[0].play();
			$videoControlButton.attr('aria-label', 'pause');
			isVideoPlaying = true;
		}

		function pauseVideo() {
			$video[0].pause();
			$videoControlButton.attr('aria-label', 'play');
			isVideoPlaying = false;
		}

		// Disable autoplay and pause for reduced motion
		if (window.noMotion) {
			$video.prop('autoplay', false).trigger('pause');
			$videoControlButton.attr('aria-label', 'play');
			isVideoPlaying = false;
		}

		// Toggle play/pause on click
		$videoControlButton.on('click', function (e) {
			if (isVideoPlaying) {
				pauseVideo();
			} else {
				playVideo();
			}
		});

		// Show button on focus, hide on blur
		$videoControlButton.on('focus', function () {
			$videoControlButtonContainer.addClass('force-visible');
		});

		$videoControlButton.on('blur', function () {
			$videoControlButtonContainer.removeClass('force-visible');
		});

		// Lazy-load video sources
		const loadVideo = function ($video) {
			$('.fallback-image').css({ 'display': 'none' });
			const videoSourceElements = $video.find('source');
			videoSourceElements.each(function (index, vidSourceElement) {
				const $vidSourceJQ = $(vidSourceElement);
				const srcUrl = $vidSourceJQ.attr('data-src');
				const smallVidSrcUrl = $vidSourceJQ.attr('data-src-small');
				if (window.innerWidth <= 767 && smallVidSrcUrl !== undefined) {
					$vidSourceJQ.attr('src', smallVidSrcUrl);
					$video.attr('width', $video.attr('data-small-width'));
					$video.attr('height', $video.attr('data-small-height'));
				} else {
					$vidSourceJQ.attr('src', srcUrl);
				}
				$video[0].load();
			});
			$video.css({
				'width': '100%',
				'height': '100%'
			});
			$videoControlButtonContainer.css({
				'display': 'block'
			});
		};

		// Load video based on network conditions
		if (navigator.connection && !!navigator.connection.effectiveType) {
			if (navigator.connection.effectiveType === '4g') {
				loadVideo($video);
			} else {
				console.log('Slow connection, showing fallback image...');
				$('.fallback-image').css({ 'opacity': '1' });
			}
		} else {
			console.log('Navigator API not supported, loading video...');
			loadVideo($video);
		}

		// Intersection Observer for video autoplay
		if (!window.noMotion) {
			const playPauseObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.intersectionRatio > 0.7) {
						if (!isVideoPlaying) playVideo();
					} else {
						if (isVideoPlaying) pauseVideo();
					}
				});
			}, {
				threshold: [0.7] // 70% visibility
			});

			playPauseObserver.observe($video[0]);
		}

		// Handle page visibility changes
		if (!window.noMotion) {
			document.addEventListener("visibilitychange", function () {
				if (document.hidden && isVideoPlaying) {
					pauseVideo();
				} else if (!document.hidden && !isVideoPlaying && $video[0].getBoundingClientRect().top < window.innerHeight * 0.3) {
					playVideo();
				}
			});
		}

		// Scroll tracking for analytics
		let lastScrollInTime = Date.now();

		const scrollObserver = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.intersectionRatio > 0.5 && entry.intersectionRatio <= 1) {
					lastScrollInTime = Date.now();
				} else if (entry.intersectionRatio <= 0.5 && lastScrollInTime !== null) {
					const duration = (Date.now() - lastScrollInTime) / 1000;
					window.dataLayer.push({
						'event': 'video_scrolled_out',
						'videoDuration': duration,
						'networkSpeed': navigator.connection ? navigator.connection.effectiveType : 'unknown'
					});
					lastScrollInTime = null;
				}
			});
		}, {
			threshold: [0.5, 1]
		});

		scrollObserver.observe($video[0]);
	});
})(jQuery);